import React, { Component } from "react";
import Translate from "../translations/Translate";

const OptionRow = ({ id, name, checked, onChange, children }) => (
  <label className="optionRow" htmlFor={id}>
    <span>{children}</span>
    <input
      id={id}
      type="checkbox"
      name={name}
      checked={checked}
      onChange={onChange}
    />
    <span className="toggle" />
  </label>
);

const SegmentedOptions = ({ title, name, value, options, onChange }) => (
  <div className="optionGroup">
    <h4>{title}</h4>
    <div className="segmentedControl">
      {options.map((option) => (
        <label key={option.value}>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  </div>
);

class FormOptions extends Component {
  render() {
    const {
      airlineName,
      logo,
      cabinradio,
      transit,
      twelveClock,
      operatedBy,
      duration,
      distanceradio,
      systemFont,
      aircraftType,
      tableNotes,
      timezone,
    } = this.props.options;

    const { changeOptions, format, setFormat } = this.props;

    return (
      <aside className="formOptions">
        <section className="optionsCard">
          <h3>
            <Translate string="nav.display-options" />
          </h3>

          <OptionRow
            id="airlinenameInput"
            name="airlineName"
            checked={airlineName}
            onChange={changeOptions}
          >
            <Translate string="nav.show-airline-name" />
          </OptionRow>

          <OptionRow
            id="durationInput"
            name="duration"
            checked={duration}
            onChange={changeOptions}
          >
            <Translate string="nav.show-duration" />
          </OptionRow>

          <OptionRow
            id="showlogoInput"
            name="logo"
            checked={logo}
            onChange={changeOptions}
          >
            <Translate string="nav.show-logo" />
          </OptionRow>

          <OptionRow
            id="transittimeInput"
            name="transit"
            checked={transit}
            onChange={changeOptions}
          >
            <Translate string="nav.show-transit" />
          </OptionRow>

          <OptionRow
            id="timeformatInput"
            name="twelveClock"
            checked={twelveClock}
            onChange={changeOptions}
          >
            <Translate string="nav.12-hour-clock" />
          </OptionRow>

          <OptionRow
            id="operatedbyInput"
            name="operatedBy"
            checked={operatedBy}
            onChange={changeOptions}
          >
            <Translate string="nav.operated-by" />
          </OptionRow>

          <OptionRow
            id="aircraftTypeInput"
            name="aircraftType"
            checked={aircraftType}
            onChange={changeOptions}
          >
            <Translate string="nav.aircraft-type" />
          </OptionRow>

          {format === "tableoutput" && (
            <OptionRow
              id="tableNotesInput"
              name="tableNotes"
              checked={tableNotes}
              onChange={changeOptions}
            >
              <Translate string="table.notes" />
            </OptionRow>
          )}
        </section>

        <section className="optionsCard">
          <SegmentedOptions
            title={<Translate string="nav.show-cabin" />}
            name="cabinradio"
            value={cabinradio}
            onChange={changeOptions}
            options={[
              { value: "off", label: <Translate string="nav.off" /> },
              { value: "className", label: <Translate string="nav.class" /> },
              { value: "cabin", label: <Translate string="nav.cabin" /> },
            ]}
          />

          <SegmentedOptions
            title={<Translate string="nav.show-distance" />}
            name="distanceradio"
            value={distanceradio}
            onChange={changeOptions}
            options={[
              { value: "off", label: <Translate string="nav.off" /> },
              { value: "km", label: <Translate string="distance.km" /> },
              { value: "miles", label: <Translate string="distance.miles" /> },
            ]}
          />
        </section>

        <section className="optionsCard">
          <h3>
            <Translate string="nav.results-format" />
          </h3>

          <div className="formatGrid">
            {[
              ["twolines", "nav.twolines"],
              ["twolinesreordered", "nav.twolinesreordered"],
              ["threelines", "nav.threelines"],
              ["threelinesreordered", "nav.threelinesreordered"],
              ["tableoutput", "nav.table"],
            ].map(([value, label]) => (
              <label className="formatOption" key={value}>
                <input
                  type="radio"
                  name="resultformat"
                  value={value}
                  checked={format === value}
                  onChange={setFormat}
                />
                <span>
                  <Translate string={label} />
                </span>
              </label>
            ))}
          </div>
        </section>

        <section className="optionsCard">
          <h3>Advanced</h3>

          <OptionRow
            id="systemFonts"
            name="systemFonts"
            checked={systemFont}
            onChange={changeOptions}
          >
            Use System Fonts
          </OptionRow>

          <OptionRow
            id="timezone"
            name="timezone"
            checked={timezone}
            onChange={changeOptions}
          >
            Show Time Zone
          </OptionRow>
        </section>
      </aside>
    );
  }
}

export default FormOptions;
